import React, { useState } from "react";
import { Button, Card, Form, Space, Affix, Anchor, Layout, Input, TimePicker, Switch, Col, Row, Select, Table, Tag, Tooltip, Divider, DatePicker, AutoComplete, Cascader, message } from 'antd';
import moment from 'moment';
import EditableTagGroup from './productTag';
import ProductSkuEdit from './productSkuEdit';

import {
  QrcodeOutlined,
  SaveOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  CheckOutlined
} from '@ant-design/icons';

import '../../form.css';

const { Link } = Anchor;
const { Header, Sider, Content } = Layout;
const { Option } = Select;
const { Search, TextArea } = Input;


interface Icategories {
  id: number,
  name: string
}

interface Icountries {
  value: string,
  label: string,
  children: any,
}

interface Iskus {
  id: number,
  code: string,
  name: string,
  price: string,
  status: boolean
}

class BasicForm extends React.Component {

  state = {
    cardbordered: false,
    guanban: false,
    categories: Array<Icategories>(),
    countries: Array<Icountries>(),
    skus: Array<Iskus>(),
    loading: true,
    total: 0,
    dataId: 0,
    editorVisible: false,
    editorTitle: "Modal Title"
  }

  categories = [
    {
      'id': 20,
      'name': '一日游'
    },
    {
      'id': 21,
      'name': '多日游'
    },
    {
      'id': 22,
      'name': '接机'
    },
    {
      'id': 23,
      'name': '送机'
    },
    {
      'id': 24,
      'name': '包车'
    },
    {
      'id': 46,
      'name': '定制游艇'
    },
    {
      'id': 47,
      'name': '定制帆船'
    },
    {
      'id': 48,
      'name': '租赁游艇'
    },
    {
      'id': 49,
      'name': '租赁帆船'
    }
  ];


  countries = [
    {
      value: '中国',
      label: '中国',
      children: [
        {
          value: '湖南省',
          label: '湖南省',
          children: [
            {
              value: '长沙市',
              label: '长沙市',
              children: [
                {
                  value: '岳麓区',
                  label: '岳麓区',
                },
              ],
            },
          ],
        },
        {
          value: '浙江省',
          label: '浙江省',
          children: [
            {
              value: '杭州市',
              label: '杭州市',
              children: [
                {
                  value: '西湖区',
                  label: '西湖区',
                },
              ],
            },
          ],
        },
      ]
    }
  ];


  sku_table_columns = [
    {
      title: 'SKU短码',
      dataIndex: 'code',
      key: 'name'
    },
    {
      title: '销售名称',
      dataIndex: 'name',
      key: 'age',
    },
    {
      title: '销售价格',
      dataIndex: 'price',
    },
    {
      title: '上下架',
      dataIndex: 'status',
      render: (text: any) => <Switch checkedChildren="上架" unCheckedChildren="下架" defaultChecked={text} />
    },
    {
      title: '操作',
      key: 'action',
      render: (text: any, record: any) => {
        return (
          <Space>
            <Button type="link" icon={<EditOutlined />} onClick={this.editData.bind(this, record.id)}>编辑</Button>
            <Button type="link" icon={<DeleteOutlined />}>删除</Button>
          </Space>
        )
      }
    },
  ];

  skus = [
    {
      id: 1,
      code: 'SWC',
      name: '幔麓大/双床2晚连住',
      price: '500.00',
      status: true
    },
    {
      id: 2,
      code: 'DKJ',
      name: '洞穴房1晚',
      price: '550.00',
      status: false
    },
  ];

  // 新增
  createData = () => {
    this.setState({
      editorVisible: true,
      editorTitle: "新增记录"
    });
  };

  // 编辑
  editData = (text: number): any => {
    this.setState({
      dataId: text,
      editorVisible: true,
      editorTitle: "编辑记录 ID - " + text.toString()
    });
  }

  // 关闭 Modal
  cancelModal = () => {
    this.setState({
      editorVisible: false,
    });
  };

  componentDidMount() {
    this.setState({
      'categories': this.categories,
      'countries': this.countries,
      'skus': this.skus
    })
  }

  render() {

    const formItemLayout = {
      labelCol: { span: 2 },
      wrapperCol: { span: 18 },
    };

    return (
      <div>
        <Form>
          <Divider orientation="left">基本信息</Divider>
          <Card
            bordered={this.state.cardbordered}
            className="prod-edit-card"
          >

            <Row>
              <Col span={4}>
                <Form.Item label="商品分类" name="layout">
                  <Input.Group compact>
                    <Select
                      defaultValue="选择分类"
                      maxTagCount={30}
                    >
                      {
                        (this.state.categories.length === 0)
                          ? null
                          : this.state.categories.map((item, index) => {
                            if (item) {
                              return (<Option value="{item.id}">{item.name}</Option>);
                            }

                            return false

                          })
                      }
                    </Select>
                  </Input.Group>

                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item label="国家地区" name="area">
                  <Cascader options={this.state.countries} placeholder="选择国家地区" />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={18}>
                <Form.Item label="售卖标题" name="layout">
                  <Input defaultValue="" placeholder=" 商品售卖标题" />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item label="商品标签" name="layout">
                  <EditableTagGroup />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item label="商品主题" name="layout">
                  <EditableTagGroup />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item label="商品亮点" name="layout">
                  <Row gutter={[16, 16]}>
                    <Col span={8}><Input placeholder="亮点一" /></Col>
                    <Col span={8}><Input placeholder="亮点二" /></Col>
                    <Col span={8}><Input placeholder="亮点三" /></Col>
                  </Row>
                </Form.Item>
              </Col>
            </Row>

            <Button type="primary" icon={<CheckOutlined />}>保存基本信息</Button>

          </Card>

          <div id="price">
            <Divider orientation="left">套餐价格设置</Divider>
            <Card
              bordered={this.state.cardbordered}
              className="prod-edit-card"
            >
              <div style={{ marginBottom: 16 }}>
                <Button icon={<PlusOutlined />} size="small" onClick={this.createData}>
                  新增 SKU
              </Button>
              </div>

              <Table columns={this.sku_table_columns} dataSource={this.state.skus} pagination={false} size="small" />

              <Form.Item label="关班设置" name="layout" style={{ 'marginTop': '25px' }}>
                <Row align="middle">
                  <Col span={2}>
                    <Switch checkedChildren="开启" unCheckedChildren="关闭" defaultChecked={false} onChange={(value) => { this.setState({ 'guanban': value }) }} />
                  </Col>
                  {this.state.guanban && (
                    <Col span={3}>
                      <TimePicker defaultOpenValue={moment('00:00:00', 'HH:mm:ss')} />
                    </Col>
                  )}
                  {this.state.guanban && (
                    <Col span={8}>
                      每天定时关闭第二天库存
                    </Col>
                  )}
                </Row>
              </Form.Item>
              <Button type="primary" icon={<CheckOutlined />} style={{ 'marginTop': '20px' }}>保存套餐设置</Button>
            </Card>
            <ProductSkuEdit dataId={this.state.dataId} editorVisible={this.state.editorVisible} editorTitle={this.state.editorTitle} onCancel={this.cancelModal} ref="child" />
          </div>

        </Form>
      </div >
    )
  }
}

export default class ProductEditor extends React.Component {

  state = {
    'cardbordered': false
  }

  columns = [
    {
      title: '商品名称',
      dataIndex: 'age',
      key: 'name'
    },
    {
      title: '商品编号',
      dataIndex: 'name',
      key: 'age',
    },
    {
      title: '操作',
      key: 'action',
      render: (text: any, record: any) => <Space><Button type="link" icon={<EditOutlined />}>相互关联</Button> <Button type="link" icon={<DeleteOutlined />}>删除</Button></Space>
    },
  ];

  data = [
    {
      key: '1',
      name: 'SWC',
      age: '幔麓大/双床2晚连住',
      price: '500.00',
    },
    {
      key: '3',
      name: 'DKJ',
      age: '洞穴房1晚',
      price: '550.00'
    },
  ];


  render() {
    return (
      <div >
        <Layout style={{ 'backgroundColor': 'white' }}>
          <h2>
            商品编辑
          </h2>
          <Layout>
            <Content style={{ 'backgroundColor': 'white', 'paddingRight': '50px' }}>
              <div id="basic">
                <div>
                  <BasicForm />
                </div>
              </div>
              <div id="desc">
                <Divider orientation="left">图文描述</Divider>
                <Card
                  bordered={this.state.cardbordered}
                  className="prod-edit-card"
                >
                  <h3>首图和视频：</h3>
                  <Row gutter={[16, 16]}>
                    <Col span={4}>
                      <div style={{ 'height': '80px', 'backgroundColor': '#eee', 'margin': '8px 0', 'padding': '8px', 'color': '#aaa', 'textAlign': 'center' }}>
                        首图
                      </div>
                    </Col>
                    <Col span={4}>
                      <div style={{ 'height': '80px', 'backgroundColor': '#eee', 'margin': '8px 0', 'padding': '8px', 'color': '#aaa', 'textAlign': 'center' }}>
                        视频
                      </div>
                    </Col>
                  </Row>
                  <h3>轮播图：</h3>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <div style={{ 'height': '80px', 'backgroundColor': '#eee', 'margin': '8px 0', 'padding': '8px', 'color': '#aaa', 'textAlign': 'center' }}>
                        轮播图区域
                      </div>
                    </Col>
                  </Row>

                  <h3>行程介绍：</h3>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <TextArea rows={20} />
                    </Col>
                  </Row>

                  <h3>预订须知：</h3>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <TextArea rows={10} />
                    </Col>
                  </Row>

                  <h3>退改须知：</h3>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <TextArea rows={10} />
                    </Col>
                  </Row>

                  <Button type="primary" icon={<CheckOutlined />} style={{ 'marginTop': '20px' }}>保存图文描述</Button>
                </Card>

              </div>
              <div id="other">
                <Divider orientation="left">其它设置</Divider>
                <Card
                  bordered={this.state.cardbordered}
                  className="prod-edit-card"
                >

                  <h3>关联推荐</h3>
                  <Table columns={this.columns} dataSource={this.data} pagination={false} size="small" />

                  <Button type="primary" icon={<CheckOutlined />} style={{ 'marginTop': '20px' }}>保存相关设置</Button>
                </Card>
              </div>
            </Content>

            <Sider width={220} className="site-layout-background" style={{ 'paddingTop': '20px' }}>
              <Anchor>
                <Link href="#basic" title="基础信息" />
                <Link href="#price" title="套餐价格" />
                <Link href="#desc" title="图文详情" />
                <Link href="#other" title="关联设置" />
              </Anchor>
              <div style={{ 'marginTop': '80px', 'padding': '0 15px 0 0' }} >
                <Affix offsetTop={160} >
                  <Button type="primary" block icon={<SaveOutlined />} onClick={() => { message.info('提交全部表单') }}>
                    提交
                  </Button>
                  <br /><br />
                  <Button type="default" block icon={<SaveOutlined />} onClick={() => { message.info('暂存所有表单数据') }}>
                    暂存
                  </Button>
                  <br /><br />
                  <Button type="default" block icon={<QrcodeOutlined />} onClick={() => { message.info('通过小程序二维码预览') }}>
                    预览
                  </Button>
                </Affix>
              </div>
            </Sider>
          </Layout>
        </Layout >
      </div >
    )
  }
}
